var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.8C23.0692 28.8 28.8 23.0693 28.8 16C28.8 8.93077 23.0692 3.20001 16 3.20001C8.93075 3.20001 3.2 8.93077 3.2 16C3.2 23.0693 8.93075 28.8 16 28.8ZM16 8.80001C16.8837 8.80001 17.6 9.51636 17.6 10.4V15.9999C17.6 16.8836 16.8837 17.5999 16 17.5999C15.1163 17.5999 14.4 16.8836 14.4 15.9999V10.4C14.4 9.51636 15.1163 8.80001 16 8.80001ZM16 19.6C17.1046 19.6 18 20.4954 18 21.6V21.616C18 22.7206 17.1046 23.616 16 23.616C14.8954 23.616 14 22.7206 14 21.616V21.6C14 20.4954 14.8954 19.6 16 19.6Z",
    fill: "#FF5865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.36f6561b5994539aeb4a6308b4bcfcab.svg";
export { ForwardRef as ReactComponent };